import * as React from "react";
import {Field} from "react-final-form";

export default class TextoInput extends React.Component<TextoInputProps, any> {

    
    render() {
        const {name, className, placeholder, maxLength, disabled, id} = this.props;
        return (
            <Field name={name}
            disabled={disabled}>
                {({input, meta}) => (
                    <div>
                        <input {...input} type={"text"} id={id} placeholder={placeholder} maxLength={maxLength} disabled={disabled}
                               className={className ? className.concat(" form-control") : "form-control"}/>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}

interface TextoInputProps {
    name: string,
    className?: string,
    placeholder?: string,
    maxLength?: number,
    disabled?: boolean,
    id?: string,
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TextoInput.tsx